var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Optional Items")]),_c('p',[_vm._v(" These items can be further configured in the advanced settings menu. ")])])}]

export { render, staticRenderFns }